/** Official ArtLove365 social channels: shown in the footer of every page and as JSON-LD `sameAs`. Add a row when a channel exists. */
export const SOCIAL_LINKS = [
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/artlove365" },
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/company/artlove365" },
  { id: "youtube", label: "YouTube", url: "https://www.youtube.com/@artlove365" },
] as const;
export type SocialId = "facebook" | "linkedin" | "instagram" | "youtube" | "x" | "pinterest" | "tiktok";
